var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5ZM.5 12C.5 5.649 5.649.5 12 .5S23.5 5.649 23.5 12 18.351 23.5 12 23.5.5 18.351.5 12Zm15.277-3.777a.8.8 0 0 1 0 1.135L13.135 12l2.642 2.642a.802.802 0 1 1-1.135 1.135L12 13.135l-2.642 2.642a.802.802 0 0 1-1.135-1.135L10.865 12 8.223 9.358a.802.802 0 0 1 1.135-1.135L12 10.865l2.642-2.642a.8.8 0 0 1 1.135 0Z"
})));
export default SvgCrossCircle;